
import React from 'react'

const DateTimePicker = ({ to, from, setTo, setFrom }) => {
    return (
        <div style={{
            display: 'flex',
        }}>
            <div style={{
                flexGrow: 1,
                marginRight: '1rem',
            }}>
                <label>From</label>
                <input type="date" value={from} max={to} onChange={(e) => setFrom(e.target.value)} />
            </div>
            <div style={{
                flexGrow: 1,
                marginLeft: '1rem',
            }}>
                <label>To</label>
                <input type="date" value={to} min={from} onChange={(e) => setTo(e.target.value)} />
            </div>
        </div>
    )
}

export default DateTimePicker
